module.exports = __webpack_public_path__ + "front/img/p2_2.ab2b39bc.png";